import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Landing from "../../Esg/Landing";
import MemberCard from "./MemberCard";
import OurCulture from "./OurCulture";
import StartedWith from "../../Esg/StartedWith";
import { useNavigate } from "react-router";

const STRENGTHS = [
  {
    title: "Multidisciplinary Expertise",
    image: "/assets/images/Team/core-strength-1.png",
    bLeft: false,
    bRight: false,
    bTop: false,
    bBottom: true,
  },
  {
    title: "Certified Professionals",
    image: "/assets/images/Team/core-strength-2.png",
    bLeft: true,
    bRight: true,
    bTop: false,
    bBottom: true,
  },
  {
    title: "Passion for Sustainability",
    image: "/assets/images/Team/core-strength-3.png",
    bLeft: false,
    bRight: false,
    bTop: false,
    bBottom: true,
  },
  {
    title: "Collaborative Culture",
    image: "/assets/images/Team/core-strength-4.png",
    bLeft: false,
    bRight: false,
    bTop: false,
    bBottom: false,
  },
  {
    title: "Innovative Technologists &\n Researchers",
    image: "/assets/images/Team/core-strength-5.png",
    bLeft: true,
    bRight: true,
    bTop: false,
    bBottom: false,
  },
  {
    title: "Experienced Consultants & \nProject Managers",
    image: "/assets/images/Team/core-strength-6.png",
    bLeft: false,
    bRight: false,
    bTop: false,
    bBottom: false,
  },
];

const SOLUTIONCHAPS = [
  {
    name: "Dr. Ganesh Bhoite",
    designation: "Co-Founder",
    image: "/assets/images/Team/dr-ganesh.png",
    linkedIn: "https://www.linkedin.com/in/dr-ganesh-bhoite-0468203b/",
  },
  {
    name: "Shreyas Das",
    designation: "Co-Founder",
    image: "/assets/images/Team/shreyas-dash.png",
    linkedIn: "https://www.linkedin.com/in/shreyasdas24/",
  },
  {
    name: "Shraddha Dudhane",
    designation: "Senior Consultant",
    image: "/assets/images/Team/shraddha.png",
    linkedIn: "https://www.linkedin.com/in/shraddha-dudhane-99349882/",
  },
  {
    name: "Vaibhavi Khanapure",
    designation: "Consultant",
    image: "/assets/images/Team/vaibhavi.png",
    linkedIn: "https://www.linkedin.com/in/vaibhavi-khanapure-8a0250209/",
  },
  {
    name: "Ankita Bisht",
    designation: "Consultant",
    image: "/assets/images/Team/ankita.png",
    linkedIn: "https://www.linkedin.com/in/ankita-k-bisht/",
  },
];

const STRATEGICMINDSBEHINDNIRANTARA = [
  {
    name: "Prasanna Rao",
    designation: "Founder",
    image: "/assets/images/Team/prasanna.png",
    linkedIn: "https://www.linkedin.com/in/prasanna-rao-89025b1b/",
  },
  {
    name: "Priya Arora",
    designation: "Chief Financial Officer (CFO)",
    image: "/assets/images/Team/priya.png",
    linkedIn: "https://www.linkedin.com/in/priya-arora-82ba603b/",
  },
  {
    name: "Capt. Vinod Nair",
    designation: "Chief Operating Officer (COO)",
    image: "/assets/images/Team/vinod.png",
    linkedIn: "https://www.linkedin.com/in/capt-vinod-nair-2668887/",
  },
  {
    name: "Kanika Goswami",
    designation: "Chief Commercial Officer (CCO)",
    image: "/coo.png",
    linkedIn: "https://www.linkedin.com/in/kanika2008",
    imageScale: 1.15,
  },
  {
    name: "Vaibhav Singh",
    designation: "Chief Technical Officer (CTO)",
    image: "/assets/images/Team/vaibhav.png",
    linkedIn: "https://www.linkedin.com/in/vaibhavsingh1/",
  },
];


function OurTeamView() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>Meet the Nirantara Team - ESG & Sustainability Experts</title>
        <meta name="description" content="Discover the multidisciplinary team behind Nirantara, including ESG consultants, sustainability experts, and leadership driving environmental, social, and governance transformation for businesses." />
        <meta name="keywords" content="Nirantara team, ESG experts, sustainability consultants team, ESG leadership, environmental consultants, ESG professionals, sustainability advisory team, Nirantara leadership" />
        <link rel="canonical" href="https://nirantara.solutions/our-team" />
      </Helmet>
      <Landing
        text={"Meet Our Team "}
        image={"/assets/images/Team/our_team.jpg"}
        imagePosition="top"
      />
      <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <div className="flex flex-col-reverse md:grid md:grid-cols-1">
          <div className="flex flex-col justify-between w-full py-0 mx-auto text-white md:py-10">
            <h1 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
              Champions of Sustainable Progress
            </h1>
            <p className="mb-4 text-[#000000] text-lg leading-10">
              At Nirantara, our people are our greatest strength. A diverse
              group of experts, innovators, and visionaries across
              sustainability, finance, manufacturing, logistics, technology, and
              strategy, we work together to make sustainability achievable for
              every business.
            </p>
          </div>
        </div>
      </section>
      <div className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#FFF]">
        <h5 className="font-bold text-center text-black text-[2.2rem] sm:pt-3">
          Core Strengths
        </h5>
        <div className="grid w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
          {STRENGTHS.map(
            ({ title, image, bLeft, bRight, bTop, bBottom }, index) => (
              <div className="border-wrapper flex items-center justify-center relative w-full">
                {/* for mobile device remove left right border */}
                {!isMobile && bLeft && (
                  <span className="border-side border-left"></span>
                )}
                {!isMobile && bRight && (
                  <span className="border-side border-right"></span>
                )}
                {!isMobile && bTop && (
                  <span className="border-side border-top"></span>
                )}
                {!isMobile && bBottom && (
                  <span className="border-side border-bottom"></span>
                )}
                {isMobile && index < STRENGTHS.length - 1 && (
                  <span className="border-side border-bottom"></span>
                )}
                <div className="flex flex-col items-center justify-center w-full h-[200px] p-5">
                  <img
                    src={image}
                    alt={title}
                    className="w-[35px] h-[35px] mb-3 rounded-full object-cover"
                  />
                  <p className="text-xl font-bold text-center whitespace-pre-wrap">
                    {title}
                  </p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
      {/* Solution Champions */}
      <div className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <h5 className="font-bold text-center text-black text-[2.2rem] sm:pt-3">
          Solution Champions
        </h5>
        <div className="grid w-full grid-cols-2 gap-5 sm:gap-6 sm:grid-cols-3 lg:grid-cols-4">
          {SOLUTIONCHAPS.map(({ name, designation, image, linkedIn }, index) => (
            <MemberCard
              key={name + "_" + index}
              image={image}
              linkedIn={linkedIn}
              name={name}
              designation={designation}
              aspectClass="aspect-square"
            />
          ))}
        </div>
      </div>



      {/* Strategic Minds */}
      <div className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <h5 className="font-bold text-center text-black text-[2.2rem] sm:pt-3">
          Strategic Minds Behind Nirantara
        </h5>
        <div className="grid w-full grid-cols-2 gap-5 sm:gap-6 sm:grid-cols-3 lg:grid-cols-4">
          {STRATEGICMINDSBEHINDNIRANTARA.map(({ name, designation, image, linkedIn, imageScale }, index) => (
            <MemberCard
              key={name + "_" + index}
              image={image}
              linkedIn={linkedIn}
              name={name}
              designation={designation}
              imageScale={imageScale}
            />
          ))}
        </div>
      </div>
      <OurCulture />
      <StartedWith
        heading={"Join Our Team "}
        content1={
          "Looking to make a positive impact in ESG and sustainability? Explore opportunities to grow with Nirantara."
        }
        button1={"View Careers"}
        btn1OnClick={() => {
          navigate("/career");
        }}
      />
    </>
  );
}

export default OurTeamView;
